import campaignAPI from '@api/campaign'
import objectToArray from '@utils/objectToArray'
import _cloneDeep from 'lodash/cloneDeep'
import { formatWidgetForApi } from '@utils/formatWidgetApi'
import {
  availableFonts,
  loadedWebFonts,
  headlineFontSizes,
  textFontSizes,
  buttonFontSizes,
  textAlign,
  flexBoxAlign,
} from '@meta/fonts'

import { SET_VISIBLE_MENU } from './_types'

const getDefaultState = () => {
  return {
    availableFontsList: availableFonts,
    loadedWebFontsList: loadedWebFonts,
    headlineFontSizesList: headlineFontSizes,
    textFontSizesList: textFontSizes,
    buttonFontSizesList: buttonFontSizes,
    textAlignList: textAlign,
    flexBoxAlignList: flexBoxAlign,
    showContentMenu: true,
    showSettingsMenu: false,
  }
}

export const state = getDefaultState()

export const getters = {}

export const mutations = {
  [SET_VISIBLE_MENU](state, name) {
    state.showContentMenu = false
    state.showSettingsMenu = false
    if (name) {
      if (name.label === 'Content') {
        state.showContentMenu = true
      } else if (name.label === 'Settings') {
        state.showSettingsMenu = true
      }
    }
  },
}

export const actions = {
  saveGlobal({ rootState, rootGetters }) {
    const campaign = _cloneDeep(rootGetters['campaign/targetCampaign'])

    const campaignWidgetItems = objectToArray(
      rootState.campaign.widget.widgetItems,
      rootState.campaign.widget.widgetItemsList,
    ).map(formatWidgetForApi) // Map each widget through the formatWidgetForApi function

    campaign.widgetItems = campaignWidgetItems

    return campaignAPI.saveCampaign(campaign)
      .then(({ response }) => {
        console.log('saveGlobal success')
      })
      .catch((error) => {
        console.error('saveGlobal ERROR', error)
      })
  },
  uploadFile({ commit }, data) {
    if (process.env.NODE_ENV === 'production') {
      return campaignAPI
        .getSignedRequest(data.file.name, data.file.type)
        .then((response) => {
          // Python JSON contains single quotes, javascript recognizes double
          const responseData = JSON.parse(response.data.replace(/'/g, '"'))
          const imageurl = responseData.url

          return campaignAPI
            .uploadFile(data.file, responseData)
            .then(({ data }) => {
              console.log(data)
              return imageurl
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          console.log(error)
          // commit(UPLOAD_FAILURE));
        })
    } else {
      return campaignAPI
        .uploadFile(data.file)
        .then(({ data }) => {
          console.log(data)
          return data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  setVisibleMenu({ commit }, name) {
    commit(SET_VISIBLE_MENU, name)
  },
}
